module.exports = __webpack_public_path__ + "img/4.9d1945e1.svg";